// Extend Window interface to include runtime env
declare global {
  interface Window {
    env?: Record<string, string>;
  }
}

// Runtime env helper - checks window.env first (Docker), falls back to build-time process.env (S3)
export const getEnv = (key: string): string | undefined => {
  return window.env?.[key] || process.env[key];
};

// Helper to trim trailing slashes from URLs
const trimTrailingSlash = (url?: string) => url?.replace(/[/]$/, "") || "";

export type AcceptTermsType = {
  url: string;
  ariaLabel: string;
  linkText: string;
  textBefore: string;
};

export type GeneralSetting = {
  apiUrl: string;
  socketUrl: string;
  amplitudeApiKey: string;
  enableDebuggingFeatures: boolean;
  recaptchaPublicKey: string;
  chatBoxMaxLength: number;
  acceptTerms?: AcceptTermsType;
  gitTag: string;
  env: string;
  country: string;
  dataDogSettings: {
    clientToken: string;
    applicationId: string;
  } | null;
};

export const generalSettings: GeneralSetting = {
  // Trim trailing / from URLs if present, since the code adds it when needed.
  apiUrl: trimTrailingSlash(getEnv("REACT_APP_API_URL") || ""),
  socketUrl: trimTrailingSlash(getEnv("REACT_APP_SOCKET_URL") || ""),
  env: getEnv("REACT_APP_ENV") || "",
  dataDogSettings: (() => {
    const clientToken = getEnv("REACT_APP_DD_RUM_CLIENT_TOKEN");
    const applicationId = getEnv("REACT_APP_DD_RUM_APPLICATION");
    return clientToken && applicationId ? { clientToken, applicationId } : null;
  })(),
  gitTag: getEnv("REACT_APP_GIT_TAG") || "no-git-tag",
  country: getEnv("REACT_APP_COUNTRY") || "",
  amplitudeApiKey: getEnv("REACT_APP_AMPLITUDE_API_KEY") || "",
  enableDebuggingFeatures:
    getEnv("REACT_APP_ENABLE_DEBUGGING_FEATURES") === "true",
  recaptchaPublicKey: getEnv("REACT_APP_RECAPTCHA_PUBLIC_KEY") || "",
  chatBoxMaxLength: 300,
};
